import { ConduentLogin, Login } from 'components';
import qs from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { env } from '../../constant/env';

const LoginSwitcher = props => {
  const location = useLocation();
  const [useConduent, setUseConduent] = useState(() => {
    // Check URL parameter first, then fall back to VITE_IS_US_REGION
    const { provider } = qs.parse(location.search);
    if (provider === 'conduent') {
      return true;
    }
    if (provider === 'stratumn') {
      return false;
    }
    return env.VITE_IS_US_REGION;
  });

  useEffect(() => {
    const { provider } = qs.parse(location.search);
    if (provider === 'conduent') {
      setUseConduent(true);
    } else if (provider === 'stratumn') {
      setUseConduent(false);
    } else {
      setUseConduent(env.VITE_IS_US_REGION);
    }
  }, [location.search]);

  return (
    <div>
      {useConduent ? <ConduentLogin {...props} /> : <Login {...props} />}
    </div>
  );
};

export default LoginSwitcher;
